import { useState } from 'react';
import { getChatTimeLeft } from '../../../utils/getChatTimeLeft';
import Close from '../../../assets/icons/trvto_close.svg';
import { supChatbotUserUpdate } from '../../../api/supportAdmin';

export default function Summary({ user, getFollowUps, setSelectedUser, updateUserData }) {
    const window = getChatTimeLeft(user.lastInteractionAt);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [tempLeadStatus, setTempLeadStatus] = useState('');
    const [statusComment, setStatusComment] = useState('');
    const leadStatus = user?.leadStatus || 'New';

    const statuses = [
        {
            value: 'New',
            label: 'New',
            description: "Lead has entered the system but hasn't been contacted yet.",
            className: 'blue',
            icon: '✨'
        },
        {
            value: 'Contacted',
            label: 'Contacted',
            description: "Initial contact has been made. Waiting for the customer's response.",
            className: 'purple',
            icon: '📞'
        },
        {
            value: 'Interested',
            label: 'Interested',
            description: 'Customer has shown interest and is discussing trip details.',
            className: 'yellow',
            icon: '💛'
        },
        {
            value: 'Follow Up',
            label: 'Follow Up',
            description: 'Customer needs more time or a scheduled follow-up.',
            className: 'orange',
            icon: '⏰'
        },
        {
            value: 'Booked',
            label: 'Booked',
            description: 'Booking confirmed and payment received.',
            className: 'green',
            icon: '✅'
        },
        {
            value: 'Closed',
            label: 'Closed',
            description: 'Lead is no longer active (not interested, duplicate, etc.).',
            className: 'red',
            icon: '✖'
        }
    ];

    return (
        <div className='summaryCard'>
            <div className='summaryItem'>
                <label>🕒 24hr Window</label>

                <span className={window.expired ? 'windowExpired' : 'windowActive'}>{window.text}</span>
            </div>

            <div className='summaryItem'>
                <label>📅 Last Interaction</label>

                <strong>{new Date(user.lastInteractionAt).toLocaleString()}</strong>
            </div>

            <div className='summaryItem'>
                <label>💬 First Interaction</label>

                <strong>{new Date(user.createdAt).toLocaleString()}</strong>
            </div>

            <div className='summaryItem'>
                <label>🔔 Follow Ups</label>

                <strong>{getFollowUps(user)}/5</strong>
            </div>

            <div className='summaryItem'>
                <span className='summaryLabel'>🎯 Lead Status</span>

                <div className='statusEdit'>
                    <span className={`leadStatusBadge ${leadStatus.replace(/\s/g, '')}`}>{leadStatus}</span>

                    <button
                        className='editStatusBtn'
                        onClick={() => {
                            setTempLeadStatus(leadStatus);
                            setShowStatusModal(true);
                        }}
                    >
                        ✏️
                    </button>
                </div>
            </div>
            {showStatusModal && (
                <div className='statusModalOverlay' onClick={() => setShowStatusModal(false)}>
                    <div className='statusModal' onClick={(e) => e.stopPropagation()}>
                        <div className='statusModalHeader'>
                            <h3>Change Lead Status</h3>

                            <button className='popupClose' onClick={() => setShowStatusModal(false)}>
                                <img src={Close} width={22} alt='' />
                            </button>
                        </div>

                        <div className='statusTimeline'>
                            {statuses.map((status, index) => (
                                <label key={status.value} className='statusItem'>
                                    <input
                                        type='radio'
                                        name='tempLeadStatus'
                                        value={status.value}
                                        checked={tempLeadStatus === status.value}
                                        onChange={(e) => setTempLeadStatus(e.target.value)}
                                    />

                                    <div className={`statusIcon ${status.className}`}>
                                        <span>{status.icon}</span>
                                    </div>

                                    {index !== statuses.length - 1 && (
                                        <div className={`statusLine ${status.className}`}></div>
                                    )}

                                    <div className='statusContent'>
                                        <h4>{status.label}</h4>
                                        <p>{status.description}</p>
                                    </div>
                                </label>
                            ))}
                        </div>

                        <div className='fieldGroup'>
                            <label>Comment (optional)</label>

                            <textarea
                                rows={3}
                                value={statusComment}
                                onChange={(e) => setStatusComment(e.target.value)}
                                placeholder='e.g. Customer confirmed payment...'
                            />
                        </div>

                        <div className='statusModalFooter'>
                            <button className='secondaryBtn' onClick={() => setShowStatusModal(false)}>
                                Cancel
                            </button>

                            <button
                                className='primaryBtn'
                                onClick={() => {
                                    updateUserData({
                                        updates: {
                                            leadStatus: tempLeadStatus
                                        },
                                        comment: statusComment
                                    });

                                    setShowStatusModal(false);
                                }}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
